/** Coerce chart year values from API/dropdown (number or string) to a finite number. */
export const toChartYear = (value) => {
  const year = Number(value);
  return Number.isFinite(year) ? year : null;
};

/**
 * Year options for dashboard claim charts.
 * Builds a contiguous year range from monthly aggregates.
 */
export const buildChartYearList = (primaryAggregates, fallbackAggregates = []) => {
  const primary = Array.isArray(primaryAggregates) ? primaryAggregates : [];
  const fallback = Array.isArray(fallbackAggregates) ? fallbackAggregates : [];
  const source = primary.length > 0 ? primary : fallback;

  const yearsWithData = source.map((row) => toChartYear(row?.year)).filter((year) => year != null);

  if (!yearsWithData.length) {
    return [new Date().getFullYear()];
  }

  const startYear = Math.min(...yearsWithData);
  const endYear = Math.max(...yearsWithData);
  const years = [];
  for (let year = startYear; year <= endYear; year++) {
    years.push(year);
  }
  return years;
};

/** Keep selected year valid when options load/change. Prefer current year when available. */
export const resolveSelectedChartYear = (yearList, selectedYear) => {
  const options =
    Array.isArray(yearList) && yearList.length > 0 ? yearList : [new Date().getFullYear()];
  const selected = toChartYear(selectedYear);
  if (selected != null && options.includes(selected)) {
    return selected;
  }
  const currentYear = new Date().getFullYear();
  if (options.includes(currentYear)) {
    return currentYear;
  }
  return options[options.length - 1];
};
